import React from 'react';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import DefaultProfile from 'assets/img/default-avatar.png';

export const MatchProfileItemLargeScreen = ({ data }) => (
  <GridContainer
    style={{
      padding: '0px 0px 30px 10px',
    }}
  >
    <GridItem xs={3} style={{ margin: '-5px 0px 0px -5px' }}>
      <img
        style={{
          margin: '10px 0px 0px 17px',
          width: '100%',
          borderRadius: '15px',
          display: 'Block',
        }}
        src={data.photoURL || DefaultProfile}
        alt={data.username || data.displayName}
      />
    </GridItem>
    <GridItem xs={4}>
      <h4
        style={{
          margin: '60px 0px 0px 0px',
          fontFamily: 'Raleway',
          fontWeight: '900',
          fontSize: '25px',
        }}
      >
        {data.username || data.displayName}
      </h4>
    </GridItem>
    <GridItem xs={4}>
      <Link to={`/user/${data.uid}`}>
        <Button
          variant='contained'
          color='primary'
          style={{
            float: 'right',
            margin: '60px 20px 0px -25px',
            background:
              'linear-gradient(90deg, rgba(163,130,251,1) 0%, rgba(72,88,220,1) 100%)',
            borderRadius: '50px',
            display: 'Block',
          }}
        >
          Go To Profile
        </Button>
      </Link>
    </GridItem>
  </GridContainer>
);

export default MatchProfileItemLargeScreen;
